import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { CustomsValidators } from '../../validators/custom.validators';
import {Observable, throwError} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AccessService {

  urlEmployeeAccess: string;
  urlValidationEmployee: string;
  urlListEmployee: string;
  urlDetailEmployee: string;
  urlEmployeeAccessApprover: string;
  urlEmployeeAccessContract: string;
  urlSearchContractor: string;
  urlContractorExcel: string;
  urlPatchApproved: string;
  urlException: string;
  urlVisitors: string;
  urlVisitorsValidatePeople: string;
  urlPeopleSearch: string;
  urlConfirmationDetails: string;
  urlvalidationPermission: string;

  constructor(private http: HttpClient) {
    this.urlEmployeeAccess = `${environment.bffBaseUrl}/pages/employee-form`;
    this.urlEmployeeAccessApprover = this.urlEmployeeAccess + '/site-access-approvers';
    this.urlEmployeeAccessContract = `${environment.bffBaseUrl}/pages/contractor-form`;
    this.urlValidationEmployee = `${environment.bffBaseUrl}/pages/validation/employee`;
    this.urlSearchContractor = `${environment.bffBaseUrl}/pages/contractor-form/contractors`;
    this.urlContractorExcel = `${environment.bffBaseUrl}/pages/validation/contractor`;
    this.urlListEmployee = `${environment.bffBaseUrl}/pages/access-list`;
    this.urlDetailEmployee = `${environment.bffBaseUrl}/pages/access-detail`;
    this.urlException = `${environment.bffBaseUrl}/pages/exception-form`;
    this.urlVisitors = `${environment.bffBaseUrl}/pages/visitors-form`;
    this.urlVisitorsValidatePeople = `${environment.bffBaseUrl}/pages/visitors-form`;
    this.urlPeopleSearch = `${environment.bffBaseUrl}/pages/people-search`;
    this.urlConfirmationDetails = `${environment.bffBaseUrl}/pages/admin-self-detailrequest/selfinfo`;
    this.urlvalidationPermission = `${environment.bffBaseUrl}/sar/accessapprovervalidated`;
    /// pages/access-detail/1?statusId=2`;
    // {{bff}}/pages/access-detail/1
  }


  getEmployeeAccess(): Observable<any> {
    const urlBuilder = this.urlEmployeeAccess;
    return CustomsValidators.isValidUrl(urlBuilder) ? this.http.get(urlBuilder) : throwError(CustomsValidators.msgNotValidUrl);
  }
  getApproverEmployeeSubZone(idSubzone): Observable<any> {
    const urlBuilder = this.urlEmployeeAccess + '/approvers?subZoneId=' + idSubzone;
    return CustomsValidators.isValidUrl(urlBuilder) ? this.http.get(urlBuilder) : throwError(CustomsValidators.msgNotValidUrl);
  }

  getApprovers(idBu, oneSapSite, oneSapZone): Observable<any> {
    const urlBuilder = this.urlEmployeeAccess + '/approvers?bu=' + idBu + '&siteCode1Sap=' + oneSapSite + '&zoneCode1Sap=' + oneSapZone;
    return CustomsValidators.isValidUrl(urlBuilder) ? this.http.get(urlBuilder) : throwError(CustomsValidators.msgNotValidUrl);
  }
  getApproversNotBu(oneSapSite, oneSapZone, type = 0): Observable<any> {
    const URLBFF = this.urlVisitors + '/GetApproversNotBu?siteCode1Sap=' + oneSapSite + '&zoneCode1Sap=' + oneSapZone;
    const urlBuilder = this.urlVisitors
      + '/GetApproversNotBu?siteCode1Sap=' + oneSapSite + '&zoneCode1Sap=' + oneSapZone + '&type=' + type;
    return CustomsValidators.isValidUrl(urlBuilder) ? this.http.get(urlBuilder) : throwError(CustomsValidators.msgNotValidUrl);
  }

  getEmployeePeople(type, ID, nationality, date1, date2, zoneId, subzoneId) {
    let national = '';
    if (nationality !== '') { national = '&nationality=' + nationality; }
    const urlBuilder = this.urlValidationEmployee
      + '?documentType=' + type + '&documentNumber=' + ID + national + '&fromDate=' + date1 + '&toDate=' + date2
      + '&zoneId=' + zoneId + '&subzoneId=' + subzoneId;
    return CustomsValidators.isValidUrl(urlBuilder) ? this.http.get(urlBuilder) : throwError(CustomsValidators.msgNotValidUrl);
  }

  getEmployeePeopleValidation(type, ID, nationality, date1, date2, zoneId, subzoneId): Observable<any> {
    let national = '';
    if (nationality !== '') { national = '&nationality=' + nationality; }
    const urlBuilder = this.urlValidationEmployee + '?documentType=' + type + '&documentNumber=' + ID + national
      + '&fromDate=' + date1 + '&toDate=' + date2 + '&zoneId=' + zoneId + '&subzoneId=' + subzoneId + '&isEmployee=True';
    return CustomsValidators.isValidUrl(urlBuilder) ? this.http.get(urlBuilder) : throwError(CustomsValidators.msgNotValidUrl);

  }

  postAccessEmployee(AccessData): Observable<any> {
    const urlBuilder = this.urlEmployeeAccess;
    return CustomsValidators.isValidUrl(urlBuilder) ? this.http.post(urlBuilder, AccessData) : throwError(CustomsValidators.msgNotValidUrl);
  }

  getAccessResult(id): Observable<any> {
    const urlBuilder = `${this.urlEmployeeAccess}/${id}`;
    return CustomsValidators.isValidUrl(urlBuilder) ? this.http.get(urlBuilder) : throwError(CustomsValidators.msgNotValidUrl);
  }

  getAccessDetails(requestnumber): Observable<any> {
    const urlBuilder = `${this.urlConfirmationDetails}/${requestnumber}`;
    return CustomsValidators.isValidUrl(urlBuilder) ? this.http.get(urlBuilder) : throwError(CustomsValidators.msgNotValidUrl);
  }

  getListEmployeeAccess(page, limit, people, filterUrl, isRequestor, isApprover): Observable<any> {
    let isrequestorParam = '&isRequestor=false';
    if (isRequestor) {
      isrequestorParam = '&isRequestor=true';
    }
    if (isApprover) {
      isrequestorParam = isrequestorParam + '&isApprover=true';
    } else {
      isrequestorParam = isrequestorParam + '&isApprover=false';
    }
    // {{bff}}/pages/access-list?page=1&limit=5&peoples=(true or false)
    const urlBuilder = this.urlListEmployee + '?page=' + page + '&limit=' + limit + '&peoples=' + people + isrequestorParam + filterUrl;
    return CustomsValidators.isValidUrl(urlBuilder) ? this.http.get(urlBuilder) : throwError(CustomsValidators.msgNotValidUrl);
  }

  getAccessDetail(id): Observable<any> {
    const urlBuilder = `${this.urlDetailEmployee}/${id}`; // + '?peoples=true'
    return CustomsValidators.isValidUrl(urlBuilder) ? this.http.get(urlBuilder) : throwError(CustomsValidators.msgNotValidUrl);
  }


  patchApproverDetails(accessId, mdmid, status): Observable<any> {
    const urlBuilder = this.urlDetailEmployee + '/' + accessId + '?accessApproverId=' + mdmid + '&statusId=' + status;
    return CustomsValidators.isValidUrl(urlBuilder) ? this.http.patch(urlBuilder, {}) : throwError(CustomsValidators.msgNotValidUrl);
  }



  getAllApproversByBu(id, oneSapSite, oneSapZone): Observable<any> {
    const urlBuilder = this.urlEmployeeAccessApprover + '?bu=' + id + '&siteCode1Sap=' + oneSapSite + '&zoneCode1Sap=' + oneSapZone;
    return CustomsValidators.isValidUrl(urlBuilder) ? this.http.get(urlBuilder) : throwError(CustomsValidators.msgNotValidUrl);
  }

  // ----------------CONTRACTOR
  getApproverContractorSubZone(idSubzone): Observable<any> {
    const urlBuilder = this.urlEmployeeAccessContract + '/approvers?subZoneId=' + idSubzone;
    return CustomsValidators.isValidUrl(urlBuilder) ? this.http.get(urlBuilder) : throwError(CustomsValidators.msgNotValidUrl);
  }

  getApproversContractor(idBu, oneSapSite, oneSapZone): Observable<any> {
    const urlBuilder = this.urlEmployeeAccessContract + '/approvers?bu=' + idBu + '&siteCode1Sap=' + oneSapSite
      + '&zoneCode1Sap=' + oneSapZone;
    return CustomsValidators.isValidUrl(urlBuilder) ? this.http.get(urlBuilder) : throwError(CustomsValidators.msgNotValidUrl);
  }



  getEmployeeContractAccess(): Observable<any> {
    const urlBuilder = this.urlEmployeeAccessContract;
    return CustomsValidators.isValidUrl(urlBuilder) ? this.http.get(urlBuilder) : throwError(CustomsValidators.msgNotValidUrl);
  }
  getContractors(type, ID, nationality, siteCode): Observable<any> {
    let national = '';
    if (nationality !== '') { national = '&nationality=' + nationality; }
    const urlBuilder = this.urlSearchContractor + '?documentType=' + type + '&documentNumber=' + ID + national + '&siteCode=' + siteCode;
    return CustomsValidators.isValidUrl(urlBuilder) ? this.http.get(urlBuilder) : throwError(CustomsValidators.msgNotValidUrl);
  }

  postAccessContractor(AccessData): Observable<any> {
    const urlBuilder = this.urlEmployeeAccessContract;
    return CustomsValidators.isValidUrl(urlBuilder) ? this.http.post(urlBuilder, AccessData) : throwError(CustomsValidators.msgNotValidUrl);
  }


  ValidatePeopleExcelContractor(formData: FormData, zoneId, subzoneId): Observable<any> {
    const urlBuilder = this.urlContractorExcel + '?zoneId=' + zoneId + '&subzoneId=' + subzoneId;
    return CustomsValidators.isValidUrl(urlBuilder) ? this.http.post(urlBuilder, formData) : throwError(CustomsValidators.msgNotValidUrl);
  }

  // ----------------Incoming Access Requests
  ChangeStatusAccess(ID, status): Observable<any> {
    const urlBuilder = this.urlDetailEmployee + '/' + ID + '?statusId=' + status;
    return CustomsValidators.isValidUrl(urlBuilder) ? this.http.patch(urlBuilder, {}) : throwError(CustomsValidators.msgNotValidUrl);
  }

  changeTerminate(ID, status, commentary): Observable<any> {
    const urlBuilder = this.urlDetailEmployee + '/' + ID + '?statusId=' + status;
    return CustomsValidators.isValidUrl(urlBuilder) ?
      this.http.patch(urlBuilder, commentary) : throwError(CustomsValidators.msgNotValidUrl);
  }

  // ----------------EXCEPTION FORM----------------------------
  getExceptionAccess(): Observable<any> {
    const urlBuilder = this.urlException;
    return CustomsValidators.isValidUrl(urlBuilder) ? this.http.get(urlBuilder) : throwError(CustomsValidators.msgNotValidUrl);
  }
  getApproverBu(idBu, oneSapSite, oneSapZone): Observable<any> {
    const urlBuilder = this.urlException + '/approvers?bu=' + idBu + '&siteCode1Sap=' + oneSapSite + '&zoneCode1Sap=' + oneSapZone;
    return CustomsValidators.isValidUrl(urlBuilder) ? this.http.get(urlBuilder) : throwError(CustomsValidators.msgNotValidUrl);
  }
  getApproverSubZone(idSubzone): Observable<any> {
    const urlBuilder = this.urlException + '/approvers?subZoneId=' + idSubzone;
    return CustomsValidators.isValidUrl(urlBuilder) ? this.http.get(urlBuilder) : throwError(CustomsValidators.msgNotValidUrl);
  }

  getApproverVisitorSubZone(idSubzone): Observable<any> {
    const urlBuilder = this.urlVisitors + '/approvers?subZoneId=' + idSubzone;
    return CustomsValidators.isValidUrl(urlBuilder) ? this.http.get(urlBuilder) : throwError(CustomsValidators.msgNotValidUrl);
  }

  postException(AccessData): Observable<any> {
    const urlBuilder = this.urlException;
    return CustomsValidators.isValidUrl(urlBuilder) ? this.http.post(urlBuilder, AccessData) : throwError(CustomsValidators.msgNotValidUrl);
  }

  getExceptionPeople(type, ID, nationality, date1, date2, accessGroup, siteRequest): Observable<any> {
    let national = '';
    let subzone = '';
    if (siteRequest.subzoneId != null) {
      subzone = '&subzoneId=' + siteRequest.subzoneId;
    }
    if (nationality !== '') { national = '&nationality=' + nationality; }
    const urlBuilder = this.urlException + '/validate?documentType=' + type + '&documentNumber=' + ID + national
      + '&fromDate=' + date1 + '&toDate=' + date2 + '&accessgroup=' + accessGroup + '&zoneId=' + siteRequest.zoneId + subzone;
    return CustomsValidators.isValidUrl(urlBuilder) ? this.http.get(urlBuilder) : throwError(CustomsValidators.msgNotValidUrl);
  }


  // ----------------VISITOR FORM----------------------------

  getVisitorAccess(): Observable<any> {
    const urlBuilder = this.urlVisitors;
    return CustomsValidators.isValidUrl(urlBuilder) ? this.http.get(urlBuilder) : throwError(CustomsValidators.msgNotValidUrl);
  }

  getApproverVisitorBu(idBu, oneSapSite, oneSapZone): Observable<any> {
    const urlBuilder = this.urlVisitors + '/approvers?bu=' + idBu + '&siteCode1Sap=' + oneSapSite + '&zoneCode1Sap=' + oneSapZone;
    return CustomsValidators.isValidUrl(urlBuilder) ? this.http.get(urlBuilder) : throwError(CustomsValidators.msgNotValidUrl);
  }

  getVisitorPeople(type, ID, nationality, siteCode): Observable<any> {
    let national = '';
    if (nationality !== '') { national = '&nationality=' + nationality; }
    const urlBuilder = this.urlVisitorsValidatePeople + '/validate?documentType=' + type + '&documentNumber=' + ID + national + '&siteCode=' + siteCode;;
    return CustomsValidators.isValidUrl(urlBuilder) ? this.http.get(urlBuilder) : throwError(CustomsValidators.msgNotValidUrl);
  }

  postAccessVisitor(Data): Observable<any> {
    const urlBuilder = this.urlVisitorsValidatePeople;
    return CustomsValidators.isValidUrl(urlBuilder) ? this.http.post(urlBuilder, Data) : throwError(CustomsValidators.msgNotValidUrl);
  }


  getPeopleSearchByMDMID(mdmiApprover): Observable<any> {
    const urlBuilder = this.urlPeopleSearch + '?mdmid=' + mdmiApprover;
    return CustomsValidators.isValidUrl(urlBuilder) ? this.http.get(urlBuilder) : throwError(CustomsValidators.msgNotValidUrl);
  }

  getPeropleSearchByletter(searchname): Observable<any> {
    const urlBuilder = this.urlPeopleSearch + '/byOne?searchData=' + searchname;
    return CustomsValidators.isValidUrl(urlBuilder) ? this.http.get(urlBuilder) : throwError(CustomsValidators.msgNotValidUrl);

  }

  // return CustomsValidators.isValidUrl(getVendorAdminByVendor) ?
  // this.http.get(getVendorAdminByVendor) : new Error(CustomsValidators.msgNotValidUrl);

  // --------------- verify permission--------------
  getValidatePermision() {
    return this.http.get(this.urlvalidationPermission);
  }
}
